import {Completable, EmployeeProductsDTO, pending, pristine} from 'kashable-mobile-common';

import { fetchProducts as fetchProductRequest } from '../apis/product';
import {RootState} from '../store';

import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';

const INITIAL_STATE: Completable<EmployeeProductsDTO> = pristine();

export const fetchProducts = createAsyncThunk('products/fetch', async (products, {rejectWithValue}) => {
    const response = await fetchProductRequest();

    if (response.error) {
        rejectWithValue(response);
    }

    return response;
});

export const productsSlice = createSlice({
    name: 'products',
    initialState: INITIAL_STATE,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        resetProducts: (state) => {
            if(state.value){
                return INITIAL_STATE;
            }

            return state;
        },
        setProductsLoading: () => {
            return pending<EmployeeProductsDTO>();
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchProducts.pending, () => {
                return pending();
            })
            .addCase(fetchProducts.fulfilled, (state, action) => {
                return action.payload;
            });
    },
});

export const selectProduct = (state: RootState) => state.products;
export const {
    setProductsLoading,
    resetProducts
} = productsSlice.actions;
export default productsSlice.reducer;
